module.exports = __webpack_public_path__ + "img/live-logo.28f2dc48.webp";